// import React, { useState } from "react";
// import { Button } from "../../Components/Button";
// import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../../Components/Card";
// import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../Components/Tabs";
// import { AdminIcon } from "../../Icons/AdminIcon";
// import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from "../../Components/Select";
// import { ScrollArea } from "../../Components/ScrollArea";
// import { Badge } from "../../Components/Badge";
// import './NewsPage.css'
// import '../../Components/CustomCheckBox.css'
// import { toast, ToastContainer } from "react-toastify";
// import { Link } from "react-router-dom";
// import { Icon } from "../../Icons/Icon";
// import CKEditorFull from "../../Components/CKEditor";


// const mockMembers = [
//   { id: 1, name: 'Anna Svensson', email: 'anna@example.com', membershipType: 'Premium', joinDate: '2023-01-15', status: 'active' },
//   { id: 2, name: 'Erik Johansson', email: 'erik@example.com', membershipType: 'Basic', joinDate: '2023-02-20', status: 'active' },
//   { id: 3, name: 'Maria Lindqvist', email: 'maria@example.com', membershipType: 'Premium', joinDate: '2023-03-10', status: 'active' },
//   { id: 4, name: 'Johan Andersson', email: 'johan@example.com', membershipType: 'VIP', joinDate: '2023-01-05', status: 'active' },
//   { id: 5, name: 'Lisa Karlsson', email: 'lisa@example.com', membershipType: 'Basic', joinDate: '2023-04-12', status: 'inactive' },
//   { id: 6, name: 'Peter Nilsson', email: 'peter@example.com', membershipType: 'Premium', joinDate: '2023-02-28', status: 'active' },
//   { id: 7, name: 'Sara Blomberg', email: 'sara@example.com', membershipType: 'VIP', joinDate: '2023-03-15', status: 'active' },
//   { id: 8, name: 'Mikael Ström', email: 'mikael@example.com', membershipType: 'Basic', joinDate: '2023-04-01', status: 'active' },
// ];

// // Mock data för mail-mallar
// const emailTemplates = [
//   { id: 1, name: 'Nyhetsbrev', subject: 'Månadsnytt från oss!', type: 'newsletter' },
//   { id: 2, name: 'Kampanj', subject: 'Exklusivt erbjudande - 30% rabatt!', type: 'campaign' },
//   { id: 3, name: 'Information', subject: 'Viktiga uppdateringar', type: 'info' },
//   { id: 4, name: 'Goodies', subject: 'Gratis resurser för dig!', type: 'goodies' },
// ];
// export const NewsPage = () => {
//     // const { toast } = useToast();
//   const [selectedMembers, setSelectedMembers] = useState<number[]>([]);
//   const [filteredMembers, setFilteredMembers] = useState(mockMembers);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [membershipFilter, setMembershipFilter] = useState('Alla');
//   const [statusFilter, setStatusFilter] = useState('Alla');
  
//   // Email form state
//   const [emailSubject, setEmailSubject] = useState('');
//   const [emailContent, setEmailContent] = useState('');
//   const [emailType, setEmailType] = useState('newsletter');
//   const [attachedFiles, setAttachedFiles] = useState<File[]>([]);
//   const [selectedTemplate, setSelectedTemplate] = useState('');
//   const [scheduledDate, setScheduledDate] = useState('');

//   // Filter members based on search and filters
//   React.useEffect(() => {
//     let filtered = mockMembers.filter(member => {
//       const matchesSearch = member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                            member.email.toLowerCase().includes(searchTerm.toLowerCase());
//       const matchesMembership = membershipFilter === 'Alla' || member.membershipType === membershipFilter;
//       const matchesStatus = statusFilter === 'Alla' || member.status === statusFilter;
      
//       return matchesSearch && matchesMembership && matchesStatus;
//     });
//     setFilteredMembers(filtered);
//   }, [searchTerm, membershipFilter, statusFilter]);

//   const handleSelectAll = () => {
//     if (selectedMembers.length === filteredMembers.length) {
//       setSelectedMembers([]);
//     } else {
//       setSelectedMembers(filteredMembers.map(m => m.id));
//     }
//   };

//   const handleSelectMember = (memberId: number) => {
//     setSelectedMembers(prev => 
//       prev.includes(memberId) 
//         ? prev.filter(id => id !== memberId)
//         : [...prev, memberId]
//     );
//   };

//   const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const files = event.target.files;
//     if (files) {
//       setAttachedFiles(prev => [...prev, ...Array.from(files)]);
//     }
//   };

//   const removeFile = (index: number) => {
//     setAttachedFiles(prev => prev.filter((_, i) => i !== index));
//   };

//   const loadTemplate = (templateId: string) => {
//     const template = emailTemplates.find(t => t.id.toString() === templateId);
//     if (template) {
//       setEmailSubject(template.subject);
//       setEmailType(template.type);
      
//       // Lägg till mall-specifikt innehåll
//       let templateContent = '';
//       switch (template.type) {
//         case 'newsletter':
//           templateContent = `Hej [Namn]!

// Här är vårt senaste nyhetsbrev med spännande uppdateringar:

// • Nya kurser lanserade denna månad
// • Kommande evenemang
// • Medlemsfördelar

// Med vänliga hälsningar,
// Teamet`;
//           break;
//         case 'campaign':
//           templateContent = `Hej [Namn]!

// Vi har ett exklusivt erbjudande bara för dig!

// 🎉 30% rabatt på alla premiumkurser
// ⏰ Erbjudandet gäller till [Datum]

// Använd kod: SAVE30

// Med vänliga hälsningar,
// Teamet`;
//           break;
//         case 'info':
//           templateContent = `Hej [Namn]!

// Vi vill informera dig om viktiga uppdateringar:

// [Skriv din information här]

// Har du frågor? Kontakta oss gärna.

// Med vänliga hälsningar,
// Teamet`;
//           break;
//         case 'goodies':
//           templateContent = `Hej [Namn]!

// Vi har något speciellt för dig! 🎁

// Ladda ner våra gratis resurser:
// • E-bok: [Titel]
// • Checklista: [Titel]
// • Bonus-material

// Med vänliga hälsningar,
// Teamet`;
//           break;
//       }
//       setEmailContent(templateContent);
//     }
//   };

//   const handleSendEmail = async () => {
//     if (!emailSubject || !emailContent || selectedMembers.length === 0) {
//     toast.error("Fyll i ämne, innehåll och välj mottagare",{
//       position:'bottom-right'
//     })
//       return;
//     }

//     // Mock API call
//     try {
//       console.log('Sending email to:', selectedMembers);
//       console.log('Subject:', emailSubject);
//       console.log('Content:', emailContent);
//       console.log('Files:', attachedFiles);
//       console.log('Type:', emailType);
//       console.log('Scheduled:', scheduledDate);

//       // Simulera API-anrop
//       await new Promise(resolve => setTimeout(resolve, 2000));

//     //   toast({
//     //     title: "Mail skickat!",
//     //     description: `Mail skickat till ${selectedMembers.length} mottagare`,
//     //   });
//       toast.success(`Mail skickat till ${selectedMembers.length} mottagare`,{
//         position:'bottom-right'
//       })
//       // Rensa formulär
//       setEmailSubject('');
//       setEmailContent('');
//       setAttachedFiles([]);
//       setSelectedMembers([]);
//       setScheduledDate('');
      
//     } catch (error) {
//     //   toast({
//     //     title: "Fel",
//     //     description: "Kunde inte skicka mail",
//     //     variant: "destructive",
//     //   });
//     toast.error("Kunde inte skicka mail",{position:'bottom-right'})
//     }
//   };

//   const handlePreview = () => {
//     // toast({
//     //   title: "Förhandsgranskning",
//     //   description: "Öppnar förhandsgranskning av mailet (mock)",
//     // });
//   };

//   const exportMemberList = () => {
//     // toast({
//     //   title: "Export",
//     //   description: "Medlemslista exporterad (mock)",
//     // });
//   };

//   return (
//     <div className="newspage-main">
//       <div className="newspage-main-container">
//         {/* Header */}
//         <div className="newspage-header-margin">
//            <Link to="/admin-home" className="admin-courses-home-link">
//             {/* <ArrowLeft className="h-4 w-4 mr-2" /> */}
//             <Icon.ArrowLeft width={16} height={16} fill='black'/> 
//             Tillbaka till Admin Panel
//           </Link>
//           <h1 className="newspage-header-text">
//             Mailutskick
//           </h1>
//           <p className="newspage-header-paragraph">Skicka nyhetsbrev, kampanjer och information till dina medlemmar</p>
//         </div>

//         <div className="newspage-main-content-container">
//           {/* Medlemslista */}
//           <div className="newspage-memberlist-grid">
//             <Card className="newspage-memberlist-card">
//               <CardHeader>
//                 <div className="newspage-memberlist-card-action">
//                   <CardTitle className="newspage-memberlist-card-action-title">
//                     {/* <Users className="h-5 w-5 text-blue-500" /> */}

//                     <span>Medlemmar ({filteredMembers.length})</span>
//                   </CardTitle>
//                   <Button onClick={exportMemberList} className='basic-button' text={''}>
//                     {/* <Download className="h-4 w-4" /> */} DOWNLOADICON
//                   </Button>
//                 </div>
//                 <CardDescription>
//                   Välj mottagare för ditt mail
//                 </CardDescription>
//               </CardHeader>
//               <CardContent>
//                 {/* Sök och filter */}
//                 <div className="newspage-memberlist-card-action-filter">
//                   <div className="newspage-memberlist-card-search">
//                     <div className="newspage-memberlist-card-search-icon">
//                         <AdminIcon.Search width={20} height={20} fill="#a2a8b3ff"/>
//                     </div>
//                     <input
//                       placeholder="Sök medlemmar..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       className="newspage-memberlist-card-search-input"
//                     />
//                   </div>
                  
//                   <div className="newspage-memberlist-card-selectlist-container">
//                     <Select value={membershipFilter} onValueChange={setMembershipFilter}>
//                       <SelectTrigger className="newspage-memberlist-card-selectlist-select-trigger">
//                         <SelectValue placeholder="Medlemskapstyp" />
//                       </SelectTrigger>
//                       <SelectContent>
//                         <SelectItem value="Alla">Alla</SelectItem>
//                         <SelectItem value="Basic">Basic</SelectItem>
//                         <SelectItem value="Premium">Premium</SelectItem>
//                         <SelectItem value="VIP">VIP</SelectItem>
//                       </SelectContent>
//                     </Select>
                    
//                     <Select value={statusFilter} onValueChange={setStatusFilter}>
//                       <SelectTrigger className="newspage-memberlist-card-selectlist-select-trigger">
//                         <SelectValue placeholder="Status" />
//                       </SelectTrigger>
//                       <SelectContent>
//                         <SelectItem value="Alla">Alla</SelectItem>
//                         <SelectItem value="active">Aktiv</SelectItem>
//                         <SelectItem value="inactive">Inaktiv</SelectItem>
//                       </SelectContent>
//                     </Select>
//                   </div>
                  
//                   <div className="newspage-memberlist-card-selectlist-select-all-button-container">
//                     <Button style={{maxWidth:'70%'}} onClick={handleSelectAll} className="submit-button" text={selectedMembers.length === filteredMembers.length ? 'Avmarkera alla' : 'Välj alla'}>
                      
//                     </Button>
//                     <Badge variant="secondary">
//                       {selectedMembers.length} valda
//                     </Badge>
//                   </div>
//                 </div>

//                 {/* Medlemslista */}
//                 <ScrollArea className="newspage-memberlist-card-selectlist-scroll-container">
//                   <div className="newspage-memberlist-card-selectlist-scroll-member-container">
//                     {filteredMembers.map((member) => (
//                       <div key={member.id} className="newspage-memberlist-card-selectlist-scroll-member-item-container">
//                         {/* <Checkbox
//                           checked={selectedMembers.includes(member.id)}
//                           onCheckedChange={() => handleSelectMember(member.id)}
//                         /> */}
                        
//                         <input className="checkbox-newspage-input" type="checkbox" checked={selectedMembers.includes(member.id)} onChange={() => handleSelectMember(member.id)}/>
                        
//                         <div className="newspage-memberlist-card-selectlist-scroll-member-item-content-container">
//                           <p className="text-sm font-medium text-gray-900 truncate">
//                             {member.name}
//                           </p>
//                           <p className="text-xs text-gray-500 truncate">
//                             {member.email}
//                           </p>
//                           <div className="flex items-center space-x-2 mt-1">
//                             <Badge 
//                               variant={member.membershipType === 'VIP' ? 'default' : 'secondary'} 
//                               className="text-xs"
//                             >
//                               {member.membershipType}
//                             </Badge>
//                             <Badge 
//                               variant={member.status === 'active' ? 'default' : 'secondary'} 
//                               className="text-xs"
//                             >
//                               {member.status}
//                             </Badge>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </ScrollArea>
//               </CardContent>
//             </Card>
//           </div>

//           {/* Mail-komposition */}
//           <div className="newspage-mailcreation-grid">
//             <Card className="newspage-mailcreation-card">
//               <CardHeader>
//                 <CardTitle className="newspage-mailcreation-card-title">
//                   <AdminIcon.Mail fill={'#7C444F'}/>
//                   <span>Skapa Mail</span>
//                 </CardTitle>
//                 <CardDescription>
//                   Komponera ditt mail och välj typ av utskick
//                 </CardDescription>
//               </CardHeader>
//               <CardContent>
//                 <Tabs defaultValue="compose" className="newspage-mailcreation-tab-container">
//                   <TabsList className="newspage-mailcreation-tab-grid">
//                     <TabsTrigger value="compose">Komponera</TabsTrigger>
//                     <TabsTrigger value="templates">Mallar</TabsTrigger>
//                     <TabsTrigger value="schedule">Schemalägg</TabsTrigger>
//                   </TabsList>
                  
//                   <TabsContent value="compose" className="newspage-mailcreation-tab-content-container">
//                     {/* Mail-typ */}
//                     <div>
//                       <label className="newspage-mailcreation-tab-content-label">
//                         Typ av mail
//                       </label>
//                       <Select value={emailType} onValueChange={setEmailType}>
//                         <SelectTrigger>
//                           <SelectValue placeholder="Välj mailtyp" />
//                         </SelectTrigger>
//                         <SelectContent>
//                           <SelectItem value="Nyhetsbrev">
//                             <div className="newspage-mailcreation-tab-content-category-container">
//                               {/* <FileText className="h-4 w-4" /> */}
//                               <AdminIcon.Document width={20} height={20}/>
//                               <span>Nyhetsbrev</span>
//                             </div>
//                           </SelectItem>
//                           <SelectItem value="Kampanj/Erbjudande">
//                             <div className="newspage-mailcreation-tab-content-category-container">
//                               {/* <Target className="h-4 w-4" /> */}
//                               <AdminIcon.Gift width={20} height={20}/>
//                               <span>Kampanj/Erbjudande</span>
//                             </div>
//                           </SelectItem>
//                           <SelectItem value="Information">
//                             <div className="newspage-mailcreation-tab-content-category-container">
//                               {/* <Mail className="h-4 w-4" /> */}
//                               <AdminIcon.Mail width={20} height={20}/>
//                               <span>Information</span>
//                             </div>
//                           </SelectItem>
//                           <SelectItem value="Goodies/Resurser">
//                             <div className="newspage-mailcreation-tab-content-category-container">
//                               {/* <Download className="h-4 w-4" /> */}
//                               <AdminIcon.DownloadArrow width={20} height={20}/>
//                               <span>Goodies/Resurser</span>
//                             </div>
//                           </SelectItem>
//                         </SelectContent>
//                       </Select>
//                     </div>

//                     {/* Ämne */}
//                     <div>
//                       <label className="newspage-mailcreation-tab-content-category-mail-labels">
//                         Ämne
//                       </label>
//                       <input
//                         style={{width:'40%'}}
//                       className="newspage-memberlist-card-search-input"
//                         placeholder="Ange mailämne..."
//                         value={emailSubject}
//                         onChange={(e) => setEmailSubject(e.target.value)}
//                       />
//                     </div>

//                     {/* Innehåll */}
//                     <div>
//                       {/* <label className="newspage-mailcreation-tab-content-category-mail-labels">
//                         Mailinnehåll
//                       </label>
//                       <textarea
//                         style={{width:'90%'}}
//                         placeholder="Skriv ditt mailinnehåll här... Du kan använda [Namn] för att personalisera mailet."
//                         value={emailContent}
//                         onChange={(e) => setEmailContent(e.target.value)}
//                         rows={12}
//                         className="newspage-memberlist-card-search-input"
//                       /> */}
//                       <CKEditorFull/>
                     
//                     </div>

//                     {/* Bilaga */}
//                     <div>
//                       <label className="newspage-mailcreation-tab-content-category-mail-labels">
//                         Bilagor
//                       </label>
//                       <div className="newspage-mailcreation-tab-content-mail-fileupload-container">
//                         <input
//                           style={{display:'none'}}
//                           type="file"
//                           multiple
//                           onChange={handleFileUpload}
//                           className="hidden"
//                           id="file-upload"
//                         />
//                         <label
//                           htmlFor="file-upload"
//                           className="newspage-mailcreation-tab-content-mail-fileupload-label"
//                         >
//                           {/* <Paperclip className="h-8 w-8 text-gray-400" /> */}
//                           <AdminIcon.Clip width={32} height={32} fill="#9ca3af"/>
//                           <span className="newspage-mailcreation-tab-content-mail-fileupload-span-text">
//                             Klicka för att ladda upp filer eller dra och släpp
//                           </span>
//                         </label>
                        
//                         {attachedFiles.length > 0 && (
//                           <div className="newspage-mailcreation-tab-content-mail-fileupload-uploaded-files-display-container">
//                             {attachedFiles.map((file, index) => (
//                               <div key={index} className="newspage-mailcreation-tab-content-mail-fileupload-uploaded-files-display-item-container">
//                                 <span className="newspage-mailcreation-tab-content-mail-fileupload-uploaded-files-display-item-filename-label">{file.name}</span>
//                                 {/* <Button
//                                   onClick={() => removeFile(index)}
//                                   className="warning-button"
//                                   text={<AdminIcon.DeleteCross/>}
//                                 /> */}
//                                 <AdminIcon.DeleteCross onClick={() => removeFile(index)}/>
//                               </div>
//                             ))}
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     {/* Åtgärdsknappar */}
//                     <div className="newspage-upload-actions-container">
//                       <Button 
//                       onClick={handlePreview} 
//                       className="submit-button" 
//                       style={{backgroundColor:'white',color:'black',width:'fit-content',display:'flex',cursor:'pointer'}} 
//                       text={<><AdminIcon.Eye width={16} height={16}/>
//                         <span style={{marginLeft:5}}>Förhandsgranska</span></>}
//                         />
                        
//                       <Button className="submit-button" 
//                       style={{display:'flex',justifyContent:'center',cursor:'pointer'}}
//                       text={<>
//                       <AdminIcon.SendPaperPlane width={16} height={16} fill="white"/>
//                       <span style={{marginLeft:5}}>Skicka Mail ({selectedMembers.length} mottagare)
//                         </span>
//                         </>} 
//                         onClick={handleSendEmail}/>
//                     </div>
//                   </TabsContent>

//                   <TabsContent value="templates" className="newspage-template-container">
//                     <p className="newspage-template-info-label">
//                       Välj en mall för att snabbt komma igång med ditt mail
//                     </p>
                    
//                     <div className="newspage-template-card-grid-container">
//                       {emailTemplates.map((template) => (
//                         <Card key={template.id} className="newspage-template-card-container">
//                           <CardContent className="newspage-template-card-content-padd">
//                             <div className="newspage-template-card-content-container">
//                               <div>
//                                 <h4 className="newspage-template-card-header">{template.name}</h4>
//                                 <p className="newspage-template-card-paragraph">{template.subject}</p>
//                                 <Badge variant="outline" className="newspage-template-card-badge-margin">
//                                   {template.type}
//                                 </Badge>
//                               </div>
//                               <Button
//                                 onClick={() => {
//                                   setSelectedTemplate(template.id.toString());
//                                   loadTemplate(template.id.toString());
//                                 }}
//                                 style={{width:'40%',cursor:'pointer'}}
//                                 className='submit-button'
//                                 text={'Använd mall'}
//                               />
//                             </div>
//                           </CardContent>
//                         </Card>
//                       ))}
//                     </div>
//                   </TabsContent>

//                   <TabsContent value="schedule" className="newspage-template-schedule">
//                     <p className="newspage-template-schedule-paragraph">
//                       Schemalägg ditt mail att skickas vid en specifik tidpunkt
//                     </p>
                    
//                     <div>
//                       <label className="newspage-template-schedule-label">
//                         Skicka datum och tid
//                       </label>
//                       <input
//                       className="newspage-template-schedule--time-input"
//                         type="datetime-local"
//                         value={scheduledDate}
//                         onChange={(e) => setScheduledDate(e.target.value)}
//                       />
//                     </div>
                    
//                     {scheduledDate && (
//                       <div className="newspage-template-schedule--time-output">
//                         <div className="newspage-template-schedule--time-output-container">
//                           <AdminIcon.SimpleCalendar  />
//                           <span className="newspage-template-schedule--time-output-text">
//                             Mailet kommer att skickas: {new Date(scheduledDate).toLocaleString('sv-SE')}
//                           </span>
//                         </div>
//                       </div>
//                     )}
//                   </TabsContent>
//                 </Tabs>
//               </CardContent>
//             </Card>
//           </div>
//         </div>
//       </div>
//       <ToastContainer />
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import { Button } from "../../Components/Button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../../Components/Card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../Components/Tabs";
import { AdminIcon } from "../../Icons/AdminIcon";
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from "../../Components/Select";
import { ScrollArea } from "../../Components/ScrollArea";
import { Badge } from "../../Components/Badge";
import { Modal } from "../../Components/Modal";
import "./NewsPage.css";
import "../../Components/CustomCheckBox.css";
import { toast, ToastContainer } from "react-toastify";

import CKEditorFull from "../../Components/CKEditor";
import { EmailTemplateModal } from "../../Components/EmailTemplateModal";
import EmailTemplateService from "../../DataService/EmailTemplateService";
import "./AdminHome.css";




export interface EmailTemplateDto {
  id: string;
  name: string;
  subject: string;
  htmlContent: string;
  type: string;        // <-- här
  isActive: boolean;
}
type RecipientDto = {
  id: string;
  name: string;
  email: string;
  source: "user" | "newslist" | "freebie";
  subscriberId?: string | null;
};

export const NewsPage = () => {
  // Recipient state
  const [recipients, setRecipients] = useState<RecipientDto[]>([]);
  const [filteredRecipients, setFilteredRecipients] = useState<RecipientDto[]>([]);
  const [selectedRecipients, setSelectedRecipients] = useState<string[]>([]);

  // Templates
  const [templates, setTemplates] = useState<EmailTemplateDto[]>([]);
  const [editingTemplate, setEditingTemplate] = useState<EmailTemplateDto | null>(null);
  const [showTemplateModal, setShowTemplateModal] = useState(false);

  // Filters
  const [searchTerm, setSearchTerm] = useState("");

  // Compose state
  const [emailSubject, setEmailSubject] = useState("");
  const [emailContent, setEmailContent] = useState(""); // CKEditor HTML
  const [emailType, setEmailType] = useState("newsletter");
  const [attachments, setAttachments] = useState<File[]>([]);
  const [scheduledDate, setScheduledDate] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  // Load recipients & templates
  const loadRecipients = async () => {
    const [users, newslist, freebies] = await Promise.all([
      EmailTemplateService.getUserRecipients(),
      EmailTemplateService.getNewsListRecipients(),
      EmailTemplateService.getFreebieRecipients(),
    ]);

    const sourcePriority: Record<RecipientDto["source"], number> = {
      user: 3,
      newslist: 2,
      freebie: 1,
    };

    const merged = new Map<string, RecipientDto>();

    const addRecipient = (recipient: RecipientDto) => {
      const emailKey = recipient.email.trim().toLowerCase();
      if (!emailKey) return;

      const existing = merged.get(emailKey);
      if (!existing) {
        merged.set(emailKey, { ...recipient, id: emailKey });
        return;
      }

      if (sourcePriority[recipient.source] > sourcePriority[existing.source]) {
        existing.source = recipient.source;
        existing.subscriberId = recipient.subscriberId ?? existing.subscriberId ?? null;
      }

      if (!existing.name && recipient.name) {
        existing.name = recipient.name;
      }

      if (!existing.subscriberId && recipient.subscriberId) {
        existing.subscriberId = recipient.subscriberId;
      }
    };

    users.forEach(u => addRecipient({ id: u.id, name: u.name, email: u.email, source: "user", subscriberId: null }));
    newslist.forEach(n => addRecipient({ id: n.id, name: n.name, email: n.email, source: "newslist", subscriberId: n.id }));
    freebies.forEach(f => addRecipient({ id: f.id, name: f.name, email: f.email, source: "freebie", subscriberId: f.id }));

    const mergedRecipients = Array.from(merged.values()).sort((a, b) => a.name.localeCompare(b.name, "sv"));

    setRecipients(mergedRecipients);
    setFilteredRecipients(mergedRecipients);
  };

  const loadTemplates = async () => {
    const t = await EmailTemplateService.getAll();
    setTemplates(t);
  };

  useEffect(() => {
    loadRecipients();
    loadTemplates();
  }, []);

  // Filtering
  useEffect(() => {
    let filtered = recipients.filter(r =>
      r.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      r.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredRecipients(filtered);
  }, [searchTerm, recipients]);

  // Toggle select
  const toggleRecipient = (id: string) => {
    setSelectedRecipients(prev =>
      prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    if (selectedRecipients.length === filteredRecipients.length) {
      setSelectedRecipients([]);
    } else {
      setSelectedRecipients(filteredRecipients.map(r => r.id));
    }
  };

  // Attachments
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setAttachments(prev => [...prev, ...Array.from(event.target.files!)]);
    }
  };

  const removeFile = (index: number) => {
    setAttachments(prev => prev.filter((_, i) => i !== index));
  };

  // Apply template
  const applyTemplate = (id: string) => {
    const t = templates.find(t => t.id === id);
    if (!t) return;

    setEmailSubject(t.subject);
    setEmailContent(t.htmlContent);
    setEmailType(t.type);

    toast.success("Mall inläst!");
  };

  const previewHtml = emailContent.trim().length > 0
    ? emailContent
    : "<p>Förhandsvisningen visas här när du skriver innehåll.</p>";

  const handlePreview = () => {
    setShowPreview(true);
  };

  // Send email
  const handleSendEmail = async () => {
    if (!emailSubject || !emailContent || selectedRecipients.length === 0) {
      toast.error("Fyll i ämne, innehåll och välj mottagare");
      return;
    }

    const recipientDetails = recipients.filter(r => selectedRecipients.includes(r.id));

    const payload = new FormData();

    payload.append("Subject", emailSubject);
    payload.append("HtmlContent", emailContent);
    payload.append("Type", emailType);
    recipientDetails.forEach(recipient => {
      payload.append("RecipientEmails", recipient.email);
      payload.append("RecipientNames", recipient.name);
      payload.append("RecipientSubscriberIds", recipient.subscriberId ?? "");
    });

    if (scheduledDate) {
      payload.append("ScheduledAt", new Date(scheduledDate).toISOString());
    }

    attachments.forEach(a => payload.append("Attachments", a));

    const ok = await EmailTemplateService.sendEmail(payload);

    if (ok.ok) {
      toast.success(ok.scheduled ? `Mail schemalagt (${ok.jobCount ?? recipientDetails.length} mottagare)` : `Mail skickat till ${recipientDetails.length} mottagare`);
      setEmailSubject("");
      setEmailContent("");
      setAttachments([]);
      setSelectedRecipients([]);
      setScheduledDate("");
    } else {
      toast.error("Kunde inte skicka mail");
    }
  };

  return (
    <div className="admin-page-shell newspage-main">
      <div className="newspage-main-container">
        
        {/* HEADER */}
        <div className="admin-page-header newspage-header-margin">
          {/* <Link to="/admin-home" className="admin-courses-home-link">
            <Icon.ArrowLeft width={16} height={16} fill="black" /> Tillbaka
          </Link> */}

          <h1 className="admin-page-title newspage-header-text">Mailutskick</h1>
          <p className="admin-page-subtitle newspage-header-paragraph">
            Skicka nyhetsbrev, kampanjer och information
          </p>
        </div>

        <div className="newspage-main-content-container">

          {/* RECIPIENT LIST */}
          <div className="newspage-memberlist-grid">
            <Card className="admin-surface-card newspage-memberlist-card" disableHover>

              <CardHeader>
                <div className="newspage-memberlist-card-action">
                  <CardTitle>Kontakter ({filteredRecipients.length})</CardTitle>
                </div>
                <CardDescription>Välj mottagare för utskicket</CardDescription>
              </CardHeader>

              <CardContent>
                
                {/* FILTERS */}
                <div className="newspage-memberlist-card-action-filter">

                  <div className="newspage-memberlist-card-search">
                    <AdminIcon.Search width={20} height={20} fill="hsl(var(--muted-foreground))" />
                    <input
                      className="newspage-memberlist-card-search-input"
                      placeholder="Sök..."
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                    />
                  </div>

                  <Button
                    onClick={toggleSelectAll}
                    className="submit-button"
                    text={selectedRecipients.length === filteredRecipients.length ? "Avmarkera alla" : "Välj alla"}
                    style={{ maxWidth: "100%" }}
                  />
                  <Badge variant="secondary">{selectedRecipients.length} valda</Badge>
                </div>

                {/* RECIPIENT LIST */}
                <ScrollArea className="newspage-memberlist-card-selectlist-scroll-container">
                  {filteredRecipients.length > 0 ? (
                    filteredRecipients.map(r => (
                      <div key={r.id} className="recipient-item">
                        <input
                          className="checkbox-newspage-input"
                          type="checkbox"
                          checked={selectedRecipients.includes(r.id)}
                          onChange={() => toggleRecipient(r.id)}
                        />

                        <div className="recipient-info">
                          <p className="text-sm font-medium">{r.name}</p>
                          <p className="text-xs text-gray-500">{r.email}</p>

                          <div className="flex gap-2 mt-1">
                            <Badge>
                              {r.source === "user"
                                ? "Medlem"
                                : r.source === "newslist"
                                  ? "Nyhetslista"
                                  : "Freebie"}
                            </Badge>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="newspage-empty-state">
                      Inga mottagare matchar sökningen.
                    </div>
                  )}
                </ScrollArea>

              </CardContent>

            </Card>
          </div>

          {/* MAIL CREATION */}
          <div className="newspage-mailcreation-grid">
            <Card className="admin-surface-card newspage-mailcreation-card" disableHover>

              <CardHeader>
                <CardTitle className="newspage-mailcreation-card-title">
                  <AdminIcon.Mail fill="hsl(var(--primary))" />
                  <span>Skapa Mail</span>
                </CardTitle>
                <CardDescription>
                  Skriv, schemalägg & använd mallar
                </CardDescription>
              </CardHeader>

              <CardContent>
                <Tabs defaultValue="compose" className="newspage-mailcreation-tab-container">

                  <TabsList className="newspage-mailcreation-tab-grid">
                    <TabsTrigger value="compose">Komponera</TabsTrigger>
                    <TabsTrigger value="templates">Mallar</TabsTrigger>
                    <TabsTrigger value="schedule">Schemalägg</TabsTrigger>
                  </TabsList>

                  {/* COMPOSE TAB */}
                  <TabsContent value="compose">
                    <div>

                      {/* Email Type */}
                      <label className="newspage-mailcreation-tab-content-label">Typ av mail</label>
                      <Select value={emailType} onValueChange={setEmailType}>
                        <SelectTrigger>
                          <SelectValue placeholder="Välj mailtyp" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="newsletter">Nyhetsbrev</SelectItem>
                          <SelectItem value="campaign">Kampanj</SelectItem>
                          <SelectItem value="info">Information</SelectItem>
                          <SelectItem value="goodies">Goodies</SelectItem>
                        </SelectContent>
                      </Select>

                      {/* Subject */}
                      <label className="newspage-mailcreation-tab-content-category-mail-labels">Ämne</label>
                      <input
                        className="newspage-memberlist-card-search-input"
                        style={{ maxWidth: "30rem" }}
                        value={emailSubject}
                        onChange={e => setEmailSubject(e.target.value)}
                        placeholder="Ämne..."
                      />

                      {/* CKEditor */}
                      <label className="newspage-mailcreation-tab-content-category-mail-labels">
                        Innehåll
                      </label>
                      <CKEditorFull value={emailContent} onChange={setEmailContent} />

                      {/* ATTACHMENTS */}
                      <label className="newspage-mailcreation-tab-content-category-mail-labels">Bilagor</label>
                      <input
                        type="file"
                        multiple
                        id="file-upload"
                        style={{ display: "none" }}
                        onChange={handleFileUpload}
                      />
                      <label htmlFor="file-upload" className="newspage-mailcreation-tab-content-mail-fileupload-label">
                        <AdminIcon.Clip width={28} height={28} fill="hsl(var(--muted-foreground))" />
                        <span>Ladda upp filer</span>
                      </label>

                      {attachments.length > 0 && (
                        <div style={{ marginTop: 12 }}>
                          {attachments.map((f, i) => (
                            <div key={i} className="file-item">
                              {f.name}
                              <AdminIcon.DeleteCross onClick={() => removeFile(i)} />
                            </div>
                          ))}
                        </div>
                      )}

                      {/* ACTION BUTTONS */}
                      <div className="newspage-upload-actions-container">
                        <Button
                          className="submit-button"
                          style={{ backgroundColor: "white", color: "black" }}
                          type="button"
                          onClick={handlePreview}
                          text={<><AdminIcon.Eye width={16} height={16} /> {scheduledDate ? "Förhandsgranska / Schemalägg" : "Förhandsgranska"}</>}
                        />

                        <Button
                          className="submit-button"
                          onClick={handleSendEmail}
                          text={
                            <>
                              <AdminIcon.SendPaperPlane width={16} height={16} fill="white" />
                              <span style={{ marginLeft: 6 }}>
                                {scheduledDate ? "Schemalägg Mail" : "Skicka Mail"} ({selectedRecipients.length})
                              </span>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </TabsContent>

                  {/* TEMPLATE TAB */}
                  <TabsContent value="templates">
                    <p className="newspage-template-info-label">Välj en mall</p>

                    <div className="newspage-template-card-grid-container">
                      {templates.length > 0 ? templates.map(t => (
                        <Card key={t.id} className="admin-surface-card newspage-template-card-container" disableHover>
                          <CardContent className="newspage-template-card-content">
                            <div className="newspage-template-card-copy">
                              <h4>{t.name}</h4>
                              <p>{t.subject}</p>
                              <Badge variant="outline">{t.type}</Badge>
                            </div>

                            <div className="newspage-template-card-actions">
                              <Button
                                className="newspage-template-card-action-button newspage-template-card-action-button--primary"
                                onClick={() => applyTemplate(t.id)}
                                text="Använd"
                              />

                              <Button
                                variant="secondary"
                                className="newspage-template-card-action-button newspage-template-card-action-button--secondary"
                                onClick={() => {
                                  setEditingTemplate(t);
                                  setShowTemplateModal(true);
                                }}
                                text="Redigera"
                              />
                            </div>
                          </CardContent>
                        </Card>
                      )) : (
                        <div className="newspage-empty-state newspage-template-empty-state">
                          Inga mallar finns ännu.
                        </div>
                      )}
                    </div>

                    {/* TEMPLATE MODAL */}
                    {showTemplateModal && (
                      <EmailTemplateModal
                        template={editingTemplate}
                        onClose={() => setShowTemplateModal(false)}
                        onSubmit={async (dto: any) => {
                          if (editingTemplate)
                            await EmailTemplateService.update(editingTemplate.id, dto);
                          else
                            await EmailTemplateService.create(dto);

                          toast.success("Mall sparad!");
                          loadTemplates();
                          setShowTemplateModal(false);
                        }}
                      />
                    )}

                  </TabsContent>

                  {/* SCHEDULE TAB */}
                  <TabsContent value="schedule">
                    <label className="newspage-template-schedule-label">
                      Skicka vid specifik tidpunkt
                    </label>
                    <input
                      type="datetime-local"
                      className="newspage-template-schedule--time-input"
                      value={scheduledDate}
                      onChange={e => setScheduledDate(e.target.value)}
                    />

                    {scheduledDate && (
                      <div className="newspage-template-schedule--time-output">
                        <AdminIcon.SimpleCalendar />
                        <span>
                          Utskick sker:{" "}
                          {new Date(scheduledDate).toLocaleString("sv-SE")}
                        </span>
                      </div>
                    )}
                  </TabsContent>

                </Tabs>
              </CardContent>

            </Card>
          </div>
        </div>

      </div>

      {showPreview && (
        <Modal onClose={() => setShowPreview(false)} className="newspage-preview-modal">
          <div className="newspage-preview-modal__header">
            <div>
              <h2 className="newspage-preview-modal__title">Förhandsgranska utskick</h2>
              <p className="newspage-preview-modal__subtitle">
                Detta är en förenklad preview av ämne och innehåll.
              </p>
            </div>
            <button className="newspage-preview-modal__close" onClick={() => setShowPreview(false)}>
              ✕
            </button>
          </div>

          <div className="newspage-preview-modal__summary">
            <div><strong>Ämne:</strong> {emailSubject || "(saknas)"}</div>
            <div><strong>Mottagare:</strong> {selectedRecipients.length}</div>
            <div><strong>Typ:</strong> {emailType}</div>
            {scheduledDate && <div><strong>Schemalagt:</strong> {new Date(scheduledDate).toLocaleString("sv-SE")}</div>}
          </div>

          <div
            className="newspage-preview-modal__body"
            dangerouslySetInnerHTML={{ __html: previewHtml }}
          />
        </Modal>
      )}

      <ToastContainer position="bottom-right" />
    </div>
  );
};
